/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPhoneBase,
  PersonPhoneBaseOptional,
  PersonPhoneBaseMetaI,
  PersonPhoneBaseTrackedI,
} from "./person-phone-base";
import {
  PersonPhoneBaseTracked,
  PersonPhoneBaseMeta,
} from "./person-phone-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneBaseDTO,
  PhoneBaseDTOOptional,
  PhoneBaseDTOMetaI,
  PhoneBaseDTOTrackedI,
} from "./phone-base-dto";
import { PhoneBaseDTOTracked, PhoneBaseDTOMeta } from "./phone-base-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneType,
  PhoneTypeOptional,
  PhoneTypeMetaI,
  PhoneTypeTrackedI,
} from "./phone-type";
import { PhoneTypeTracked, PhoneTypeMeta } from "./phone-type";

/**
 *
 * @export
 * @interface PhoneDTO
 */
export interface PhoneDTOOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  number?: string;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneDTO
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isBad?: boolean;
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  personPhoneAssignId?: number;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  name?: string;
}

export interface PhoneDTO
  extends PhoneDTOOptional, Deletable, PersonPhoneBase, PhoneBaseDTO {
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  number: string;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneDTO
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isBad?: boolean;
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  personPhoneAssignId: number;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  name?: string;
}

export interface PhoneDTOTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  number?: string;
  numberIsSet: boolean;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneDTO
   */
  type?: PhoneType;
  typeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isVerified?: boolean;
  isVerifiedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isBad?: boolean;
  isBadIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PhoneDTO
   */
  personPhoneAssignId?: number;
  personPhoneAssignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneDTO
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PhoneDTO
   */
  name?: string;
  nameIsSet: boolean;
}

transformDatesMap.set("PhoneDTO", function (model: PhoneDTO) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type PhoneDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  number: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  type: PropertyMeta<PhoneTypeMetaI>;
  //isDate: false
  //isDatetime: false
  isVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isBad: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personPhoneAssignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PhoneDTOMeta: PhoneDTOMetaI = {} as PhoneDTOMetaI;
PhoneDTOMeta = typeMeta("PhoneDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  number: propertyMeta("number", false, true, false, MetaTypesBase.string),
  type: propertyMeta("type", false, false, false, PhoneTypeMeta),
  isVerified: propertyMeta(
    "isVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isBad: propertyMeta("isBad", false, false, false, MetaTypesBase.boolean),
  personPhoneAssignId: propertyMeta(
    "personPhoneAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  name: propertyMeta("name", false, false, false, MetaTypesBase.string),
});

const metaI = PhoneDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PhoneBaseDTOMeta]);
  metaI.assignId.inheritedFrom = PhoneBaseDTOMeta.assignId;
  metaI.isDeleted.inheritedFrom = PhoneBaseDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = PhoneBaseDTOMeta.isNew;
  metaI.number.inheritedFrom = PhoneBaseDTOMeta.number;
  metaI.type.inheritedFrom = PhoneBaseDTOMeta.type;
  metaI.isVerified.inheritedFrom = PhoneBaseDTOMeta.isVerified;
  metaI.isBad.inheritedFrom = PhoneBaseDTOMeta.isBad;
  metaI.interfaces = metaI.interfaces.concat([PersonPhoneBaseMeta]);
  metaI.personPhoneAssignId.inheritedFrom =
    PersonPhoneBaseMeta.personPhoneAssignId;
  metaI.startActive.inheritedFrom = PersonPhoneBaseMeta.startActive;
  metaI.endActive.inheritedFrom = PersonPhoneBaseMeta.endActive;
  metaI.isPrimary.inheritedFrom = PersonPhoneBaseMeta.isPrimary;
  metaI.name.inheritedFrom = PersonPhoneBaseMeta.name;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class PhoneDTOTracked
  extends DeletableTracked
  implements PhoneDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  number__I?: string = undefined;
  numberIsSet: boolean = false;
  set number(v: undefined | string) {
    if (v !== undefined) {
      this.number__I = v;
      this.numberIsSet = true;
    } else {
      this.number__I = v || undefined;
      this.numberIsSet = true;
    }
    this.changeTracker = true;
  }
  get number() {
    return this.number__I;
  }
  type__I?: PhoneType = undefined;
  typeIsSet: boolean = false;
  set type(v: undefined | PhoneType) {
    if (v !== undefined) {
      this.type__I = v;
      this.typeIsSet = true;
    } else {
      this.type__I = v || undefined;
      this.typeIsSet = false;
    }
    this.changeTracker = true;
  }
  get type() {
    return this.type__I;
  }
  isVerified__I?: boolean = undefined;
  isVerifiedIsSet: boolean = false;
  set isVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.isVerified__I = v;
      this.isVerifiedIsSet = true;
    } else {
      this.isVerified__I = v || undefined;
      this.isVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isVerified() {
    return this.isVerified__I;
  }
  isBad__I?: boolean = undefined;
  isBadIsSet: boolean = false;
  set isBad(v: undefined | boolean) {
    if (v !== undefined) {
      this.isBad__I = v;
      this.isBadIsSet = true;
    } else {
      this.isBad__I = v || undefined;
      this.isBadIsSet = false;
    }
    this.changeTracker = true;
  }
  get isBad() {
    return this.isBad__I;
  }
  personPhoneAssignId__I?: number = undefined;

  get personPhoneAssignIdIsSet() {
    return this.personPhoneAssignId !== undefined;
  }
  set personPhoneAssignIdIsSet(v: boolean) {}
  set personPhoneAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personPhoneAssignId__I = v;
      this.personPhoneAssignIdIsSet = true;
    } else {
      this.personPhoneAssignId__I = v || undefined;
      this.personPhoneAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personPhoneAssignId() {
    return this.personPhoneAssignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = false;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  constructor(config?: PhoneDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (
      this.personPhoneAssignIdIsSet == true &&
      other?.personPhoneAssignIdIsSet == true
    )
      return this.personPhoneAssignId == other.personPhoneAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    if (this.anySet() && !!this.personPhoneAssignId) {
      this.personPhoneAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: PhoneDTOOptional,
    options?: AssignOptions,
  ): PhoneDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.number && this.numberApplyFilter(optionsRequired.filter)) {
      this.number = config.number;
      if (optionsRequired.unassign) this.numberIsSet = false;
      else this.numberIsSet = true;
    }
    if (config.type && this.typeApplyFilter(optionsRequired.filter)) {
      this.type = config.type;
      if (optionsRequired.unassign) this.typeIsSet = false;
      else this.typeIsSet = true;
    }
    if (
      config.isVerified &&
      this.isVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.isVerified = config.isVerified;
      if (optionsRequired.unassign) this.isVerifiedIsSet = false;
      else this.isVerifiedIsSet = true;
    }
    if (config.isBad && this.isBadApplyFilter(optionsRequired.filter)) {
      this.isBad = config.isBad;
      if (optionsRequired.unassign) this.isBadIsSet = false;
      else this.isBadIsSet = true;
    }
    if (
      config.personPhoneAssignId &&
      this.personPhoneAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personPhoneAssignId = config.personPhoneAssignId;
      if (optionsRequired.unassign) this.personPhoneAssignIdIsSet = false;
      else this.personPhoneAssignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PhoneDTOTrackedI {
    const cloned = {} as PhoneDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.numberIsSetDeep() &&
      this.numberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.numberIsSet = true;
      cloned.number = this.number;
    } else {
      //cloned.numberIsSet = false
    }
    if (
      this.typeIsSetDeep() &&
      this.typeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIsSet = true;
      cloned.type = this.type;
    } else {
      //cloned.typeIsSet = false
    }
    if (
      this.isVerifiedIsSetDeep() &&
      this.isVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isVerifiedIsSet = true;
      cloned.isVerified = this.isVerified;
    } else {
      //cloned.isVerifiedIsSet = false
    }
    if (
      this.isBadIsSetDeep() &&
      this.isBadApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isBadIsSet = true;
      cloned.isBad = this.isBad;
    } else {
      //cloned.isBadIsSet = false
    }
    if (
      this.personPhoneAssignIdIsSetDeep() &&
      this.personPhoneAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personPhoneAssignIdIsSet = true;
      cloned.personPhoneAssignId = this.personPhoneAssignId;
    } else {
      //cloned.personPhoneAssignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.personPhoneAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PhoneDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.numberApplyFilter(filter)) this.numberIsSet = false;

    if (!this.typeApplyFilter(filter)) this.typeIsSet = false;

    if (!this.isVerifiedApplyFilter(filter)) this.isVerifiedIsSet = false;

    if (!this.isBadApplyFilter(filter)) this.isBadIsSet = false;

    if (!this.personPhoneAssignIdApplyFilter(filter))
      this.personPhoneAssignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.assignId, PhoneDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.isDeleted, PhoneDTOMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.isNew, PhoneDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  numberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.number, PhoneDTOMeta, this.number, this);
  }
  numberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.numberIsSet && this.numberApplyFilter(filter)) return true;

    return false;
  }
  typeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.type, PhoneDTOMeta, this.type, this);
  }
  typeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIsSet && this.typeApplyFilter(filter)) return true;

    return false;
  }
  isVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.isVerified, PhoneDTOMeta, this.isVerified, this);
  }
  isVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isVerifiedIsSet && this.isVerifiedApplyFilter(filter)) return true;

    return false;
  }
  isBadApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.isBad, PhoneDTOMeta, this.isBad, this);
  }
  isBadIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isBadIsSet && this.isBadApplyFilter(filter)) return true;

    return false;
  }
  personPhoneAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PhoneDTOMeta.personPhoneAssignId,
      PhoneDTOMeta,
      this.personPhoneAssignId,
      this,
    );
  }
  personPhoneAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personPhoneAssignIdIsSet &&
      this.personPhoneAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PhoneDTOMeta.startActive,
      PhoneDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.endActive, PhoneDTOMeta, this.endActive, this);
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.isPrimary, PhoneDTOMeta, this.isPrimary, this);
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneDTOMeta.name, PhoneDTOMeta, this.name, this);
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.numberIsSetDeep(filter)) return true;
    if (this.typeIsSetDeep(filter)) return true;
    if (this.isVerifiedIsSetDeep(filter)) return true;
    if (this.isBadIsSetDeep(filter)) return true;
    if (this.personPhoneAssignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    if (this.nameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
